// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product_card_container__F3Mmi {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 250px;
  margin: 2px;
  border: 1px solid #ddd;
  padding: 0 0 8px 0;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  overflow: hidden;
}

/* Reduire la largeur de la carte pour les petits écrans */
@media (max-width: 768px) {
  .product_card_container__F3Mmi {
    max-width: 100%;
  }
}

.product_card_addButton__fNvzU {
  height: 28px;
  width: 28px;
  position: absolute;
  border-radius: 50%;
  border: #46b38c 2px solid;
  font-size: 1.2rem;
  font-weight: 600;
  background-color: #ffffff;
  color: #46b38c;
  right: 5px;
  top: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out;
  cursor: pointer;
}

.product_card_addButton__fNvzU:hover {
  background-color: #46b38c;
  color: #ffffff;
}

.product_card_quantityButtons__5qnA1 {
  cursor: default !important;
  position: absolute;
  background-color: #46b38c;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  width: 90%; /* Largeur du bouton */
  align-items: center;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1.3rem;
  top: 10px; /* Positionne l'élément légèrement en bas du haut de la carte */
  left: 50%; /* Centre horizontalement */
  transform: translateX(-50%);
}

.product_card_productImage__BeAwY {
  max-width: 100%;
  height: auto;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.product_card_productInfo__fEdlD {
  padding: 0 10px;
  text-align: left;
  margin-top: 2px;
}

.product_card_productPrice__fVVSr {
  font-weight: bold;
  font-size: 0.9rem;
}

.product_card_productName__SQrLa {
  margin-top: 2px;
  font-size: 0.9rem;
}

.product_card_promotionPercentage__ztViS {
  background-color: #ef9034;
  border-radius: 10px;
}

.product_card_newBadge__G5UVD {
  /* background-color: var(--global-main-color); */
  /* background-color: #fff; */
  color: var(--global-main-color);
  border-radius: 10px;
  padding: 10px;
  font-size: 1.5rem;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/shop/components/product_card/product_card.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,UAAU,EAAE,sBAAsB;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS,EAAE,+DAA+D;EAC1E,SAAS,EAAE,2BAA2B;EACtC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 250px;\n  margin: 2px;\n  border: 1px solid #ddd;\n  padding: 0 0 8px 0;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background-color: #ffffff;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Reduire la largeur de la carte pour les petits écrans */\n@media (max-width: 768px) {\n  .container {\n    max-width: 100%;\n  }\n}\n\n.addButton {\n  height: 28px;\n  width: 28px;\n  position: absolute;\n  border-radius: 50%;\n  border: #46b38c 2px solid;\n  font-size: 1.2rem;\n  font-weight: 600;\n  background-color: #ffffff;\n  color: #46b38c;\n  right: 5px;\n  top: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out;\n  cursor: pointer;\n}\n\n.addButton:hover {\n  background-color: #46b38c;\n  color: #ffffff;\n}\n\n.quantityButtons {\n  cursor: default !important;\n  position: absolute;\n  background-color: #46b38c;\n  color: #ffffff;\n  display: flex;\n  justify-content: space-between;\n  width: 90%; /* Largeur du bouton */\n  align-items: center;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 1.3rem;\n  top: 10px; /* Positionne l'élément légèrement en bas du haut de la carte */\n  left: 50%; /* Centre horizontalement */\n  transform: translateX(-50%);\n}\n\n.productImage {\n  max-width: 100%;\n  height: auto;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n\n.productInfo {\n  padding: 0 10px;\n  text-align: left;\n  margin-top: 2px;\n}\n\n.productPrice {\n  font-weight: bold;\n  font-size: 0.9rem;\n}\n\n.productName {\n  margin-top: 2px;\n  font-size: 0.9rem;\n}\n\n.promotionPercentage {\n  background-color: #ef9034;\n  border-radius: 10px;\n}\n\n.newBadge {\n  /* background-color: var(--global-main-color); */\n  /* background-color: #fff; */\n  color: var(--global-main-color);\n  border-radius: 10px;\n  padding: 10px;\n  font-size: 1.5rem;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `product_card_container__F3Mmi`,
	"addButton": `product_card_addButton__fNvzU`,
	"quantityButtons": `product_card_quantityButtons__5qnA1`,
	"productImage": `product_card_productImage__BeAwY`,
	"productInfo": `product_card_productInfo__fEdlD`,
	"productPrice": `product_card_productPrice__fVVSr`,
	"productName": `product_card_productName__SQrLa`,
	"promotionPercentage": `product_card_promotionPercentage__ztViS`,
	"newBadge": `product_card_newBadge__G5UVD`
};
export default ___CSS_LOADER_EXPORT___;
